import { Record as record } from 'immutable';

import validation from '../../validation';
import ValidationMixin from '../ValidationMixin';

const defaults = {
    email: '',
    confirmEmail: '',
    phone: ''
};


class ContactForm extends record(defaults) {

    static fromJSON (json = {}) {
        return new ContactForm(json);
    }

    getSchema () {
        return {
            email: validation.email(),
            confirmEmail: validation.confirmEmail(),
            phone: validation.phone().allow('')
        };
    }

    setContactDetails (email, phone, confirmEmail) {
        return this.merge({ email, phone, confirmEmail });
    }

}


Object.assign(ContactForm.prototype, ValidationMixin);


export default ContactForm;



// WEBPACK FOOTER //
// ./src/records/payment/ContactForm.js